import React from 'react'

import { connect } from 'react-redux'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import { Container, Card, Button } from 'react-bootstrap'

import { userCan } from 'src/store/user/userActions'
import { useQuery, route } from 'src/utils/routes'
import { IState } from 'src/store'

import Error401 from 'src/pages/Error/401.page'
import Header from 'src/components/Layout/Header/Header'
import ProductForm from 'src/components/Product/ProductForm'
import ProductsUpload from 'src/components/Product/ProductsUpload'

interface IProps extends RouteComponentProps {
  history: any
  user: any
  userCan: (permission: string) => boolean
}

const ProductCreate: React.FC<IProps> = ({ history, user, userCan }) => {
  const brand = useQuery().get('brand')

  if (!userCan('create_product')) return <Error401 />

  return (
    <>
      <Header
        title={brand && brand !== '' ? 'Upload Bulk' : 'New Product'}
        backText="Products"
        onBack={() => history.push(route('products'))}
      />
      <div className="page-container">
        <Container>
          <Card>
            <Card.Header className={brand && brand !== '' ? 'centered' : null}>
              <Card.Title>
                {brand && brand !== '' ? 'Upload File' : 'Product Details'}
              </Card.Title>

              {brand && brand === 'possible' && userCan('create_product') && (
                <div>
                  <Link to={`${route('competition_create')}?type=bulk`}>
                    <Button size="sm">Create Bulk</Button>
                  </Link>
                </div>
              )}
            </Card.Header>
            <Card.Body className="pt-0">
              {brand && brand !== '' ? (
                <ProductsUpload user={user} brand={brand} />
              ) : (
                <ProductForm user={user} />
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  )
}

export default connect((state: IState) => ({ user: state.user }), { userCan })(
  withRouter(ProductCreate)
)
